import classes from '../index.module.scss'
import { Description } from './Description'
import { TitleAndContact } from './TitleAndContact'

export const StandardUserContent = () => {
  return (
    <div className={classes.standardLayout}>
      <TitleAndContact />
      <Description />
    </div>
  )
}
